import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenBeneficiaryDeleteAction from './communityGardenBeneficiaryDelete.action.json' with { type: 'json' }
import { communityGardenBeneficiaryObject } from '../../communityGarden/communityGardenBeneficiaryObject'

const communityGardenBeneficiaryDeleteDefinition = defineAction({
  ...communityGardenBeneficiaryDeleteAction,

  input: z.object({ id: communityGardenBeneficiaryObject.shape.id }),
  output: z.object({}),
})

export default communityGardenBeneficiaryDeleteDefinition
